import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
import { GrIcon } from "../icons/GrIcon";
const StyledHelperMessage = styled.span(({ error, style }) => ({
    color: error ? palette["negative-primary"] : palette.grey060,
    ...typography["Content.Body04"],
    display: "flex",
    alignItems: "center",
    gap: "4px",
    margin: 0,
    ...style,
}));
export function GrHelperMessage({ text, error, hasIcon = true, className, ...props }) {
    return (_jsxs(StyledHelperMessage, { className: classNames("GrHelperMessage", className), error: error, ...props, children: [hasIcon && _jsx(GrIcon, { color: error ? "negative-primary" : "grey060", size: 14, type: "alert-circle-filled" }), text] }));
}
//# sourceMappingURL=GrHelperMessage.js.map